import MDBox from "components/MDBox";

function Index(props?: any): JSX.Element {
  console.log("props ", props);

  return <MDBox mt={3}>Facilities settings</MDBox>;
}

export default Index;
